"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseStatusValidator = void 0;
var constants_1 = require("../constants");
var ResponseStatusValidator = /** @class */ (function () {
    function ResponseStatusValidator() {
        var _this = this;
        this.getPureRestStatusIsValid = function (_a) {
            var isPureFileRequest = _a.isPureFileRequest, status = _a.status;
            return function () {
                // for text and blob response does not matter response to parse
                // but does matter what code we get from the backend
                // also 404 is useful that can contain some data
                // and we need to provide that code to the client
                return isPureFileRequest
                    ? status === 200 || status === 304 || status === 404
                    : status <= 500;
            };
        };
        this.getRestStatusIsValid = function (_a) {
            var status = _a.status;
            return function () {
                return status <= 500;
            };
        };
        this.getJSONRPCStatusIsValid = function (_a) {
            var isBatchRequest = _a.isBatchRequest, status = _a.status;
            return function () {
                return isBatchRequest ? status < 400 : status <= 500;
            };
        };
        this.getFormatValidateMethod = function (_a) {
            var requestProtocol = _a.requestProtocol, isBatchRequest = _a.isBatchRequest, isPureFileRequest = _a.isPureFileRequest, status = _a.status;
            switch (requestProtocol) {
                case constants_1.requestProtocolsMap.jsonRpc:
                    return _this.getJSONRPCStatusIsValid({
                        isBatchRequest: isBatchRequest,
                        isPureFileRequest: isPureFileRequest,
                        status: status,
                    });
                case constants_1.requestProtocolsMap.pureRest:
                    return _this.getPureRestStatusIsValid({
                        isBatchRequest: isBatchRequest,
                        isPureFileRequest: isPureFileRequest,
                        status: status,
                    });
                default:
                    return _this.getRestStatusIsValid({
                        isBatchRequest: isBatchRequest,
                        isPureFileRequest: isPureFileRequest,
                        status: status,
                    });
            }
        };
    }
    ResponseStatusValidator.getIsStatusCodeSuccess = function (status) { return status < 400; };
    return ResponseStatusValidator;
}());
exports.ResponseStatusValidator = ResponseStatusValidator;
